import { memoize } from 'proxy-memoize'
import { MarketingDataKeys, MarketingStore } from 'store/marketing/types'
import { EV_FLEX_SIMULATION_SO } from 'features/bolt-drive-flex/BoltDriveFlex.constants'

/**
 * Selector to check if the Bolt Drive Flex flow is active.
 * @param {MarketingStore} store
 * @returns {boolean}
 */
export const selectIsBoltDriveFlexFlow = memoize<MarketingStore, boolean>(
  (marketingStore) => marketingStore[MarketingDataKeys.SIMULATION_SO] === EV_FLEX_SIMULATION_SO
)
